import { Injectable } from '@angular/core';
import {
  Resolve, RouterStateSnapshot, ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { EventListStore } from './event-list.store';
import { Page } from '../../shared/models/page';
import { OnyxSummaryEvent } from '../models/event.summary';
import { EventSearchParametersStore } from './event-search-parameters.store';
import { OrderedSet } from 'immutable';
import { SearchEventUtils } from '../utils/search-event-utils';
import { LogService } from '../../shared/log/log.service';
import { EventSearchFilter } from '../models/event-filter';
import { Constants } from '../../shared/constants';
import { PagesizeType } from './pagination/pagesize-type';
import { UserLocalStorageService } from '../../permission/services/user.local.storage.service';

@Injectable()
export class EventsResolver implements Resolve<any> {

  constructor(private eventsListStore: EventListStore,
              private searchParametersStore: EventSearchParametersStore,
              private logService: LogService,
              private userLocalStorageService: UserLocalStorageService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Page<OnyxSummaryEvent>> {
    const searchTextList: OrderedSet<string> = SearchEventUtils.convertParamsToSearchTextSet(route.queryParams);
    const searchFilterList: OrderedSet<EventSearchFilter> = SearchEventUtils.convertParamsToSearchFilterSet(route.queryParams);

    if (searchTextList.isEmpty() && searchFilterList.isEmpty()) {
      this.searchParametersStore.reset(true);
    } else {
      if (searchTextList) {
        this.searchParametersStore.setSearchTextSet(searchTextList);
      }
      if (searchFilterList) {
        this.searchParametersStore.setFilterSet(searchFilterList);
      }
    }

    this.logService.debug('route.url: ' + route.url);
    this.logService.debug('state.url: ' + state.url);

    if (route.data && route.data[ 'view' ]) {
      this.logService.debug('route.data[ \'view\' ]: ' + route.data[ 'view' ]);
      const showDefaultView = route.data['view'] as string;
      this.logService.debug('showDefaultView: ' + showDefaultView);

      this.searchParametersStore.setDefaultViewSelected(showDefaultView === 'default');

    }

    return this.eventsListStore.loadEvents(Constants.SEARCH_DEFAULT_PAGE,
      this.userLocalStorageService.getPagesize(PagesizeType.EVENTS));
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/events.resolver.ts